import React, { useContext, useEffect, useRef } from 'react'
import styles from './styles.module.css'
import { Input, Select, Textarea } from '../../../components/ModalInputs'
import { sex, docTypes } from '../../../assets/const'
import { useDispatch, useSelector } from 'react-redux'
import { StaffRosterContext } from '../../../utils/context'
import { getKindWork, getOKIN, getStaffPositionGuk, getTeacherAttestation, getWorkerTypes } from '../../../actions/common'
import { arrayForSelect } from '../../../utils/arrayForSelect'
import CustomSelect from '../../../components/CustomSelect'
import { getSuggestions } from '../../../actions/personnel/personnel'


const job = [
  { name: 'воспитатель' },
  { name: 'методист' }]
const job2 = [
  { name: 'преподаватель' },
  { name: 'старший вожатый' }]
const job3 = [
  { name: 'Начальник училища' },
  { name: 'Начальник НУ' }]
const job4 = [
  { name: 'постоянно' },
  { name: 'временно' },
  { name: 'прикомандирован' }]
const job5 = [
  { name: 'преподаватели' },
  { name: 'обсл.персонал' },
  { name: 'администрация' },
  { name: 'воспитатели' },
  { name: 'медработники' },
  { name: 'педагоги ДОП' },
  { name: 'УВ персонал' },
  { name: 'педагогические работники' },
  { name: 'педагогические работники' },
  { name: 'педагогические работники' },
]
const job6 = [
  { name: 'постоянно' },
]

// Состояние в браке (по ОКИН)
const maritalStatuses = [
  { name: '', value: '' },
  { name: 'Никогда не состоял(а) в браке', value: '1' },
  { name: 'Состоит в зарегистрированном браке', value: '2' },
  { name: 'Состоит в незарегистрированном браке', value: '3' },
  { name: 'Вдовец (вдова)', value: '4' },
  { name: 'Разведен(а) официально', value: '5' },
  { name: 'Разошелся(лась)', value: '6' }
]

// Гражданство по ОКИН
const citizenships = [
  { name: '', value: '' },
  { name: 'Гражданин Российской Федерации', value: '1' },
  { name: 'Гражданин Российской Федерации и иностранного государства (двойное гражданство)', value: '2' },
  { name: 'Иностранный гражданин', value: '3' },
  { name: 'Лицо без гражданства', value: '4' }
]

const selectValues = [
  { name: 'Работает', value: 'Работает', id: 1 },
  { name: 'Уволен', value: 'Уволен', id: 2 },
  { name: 'Убыл', value: 'Убыл', id: 3 },
  { name: 'Все', value: 'Все', id: 0 },
]
export default function Main() {

  const dispatch = useDispatch()

  const { allForms, addMode, personTabData, updateInitialValues } = useContext(StaffRosterContext)
  const { workerTypes, staffPositionGuk, teacherAttestation, kindWork, okin } = useSelector(state => state.common)

  const { values, setFieldValue, setValues } = allForms

  const { main } = personTabData || {}

  // Получаем значения вкладки main
  const mainValues = values.main || {}

  // Ref для отслеживания последних загруженных данных (чтобы избежать повторной синхронизации)
  const lastSyncedMainRef = useRef(null)

  // Кастомный handleChange для вложенных полей
  const handleMainChange = (e) => {
    const { name, value, type, checked } = e.target
    setFieldValue(`main.${name}`, type === 'checkbox' ? checked : value)
  }

  // Кастомный setFieldValue для вложенных полей
  const setMainFieldValue = (name, value) => {
    setFieldValue(`main.${name}`, value)
  }

  const renderOptions = ({ name, value }) => <option value={value}>{name}</option>

  const generateOptions = (arr) => arr.map(renderOptions)

  // Загрузка справочников
  useEffect(() => {
    dispatch(getWorkerTypes())
    dispatch(getStaffPositionGuk())
    dispatch(getTeacherAttestation())
    dispatch(getKindWork())
    dispatch(getSuggestions('kindwork'))
    dispatch(getOKIN("02"))
  }, [dispatch])

  // Синхронизация формы с данными из API
  useEffect(() => {
    // Проверяем что данные изменились (сравниваем с последними синхронизированными)
    const mainJson = JSON.stringify(main)
    if (!addMode && main && lastSyncedMainRef.current !== mainJson) {
      lastSyncedMainRef.current = mainJson
      setValues(prev => ({
        ...prev,
        main: { ...main }
      }))
      // Сохраняем начальные значения для отслеживания изменений
      if (updateInitialValues) {
        updateInitialValues('main', main)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [main, addMode])

  return (
    <div className={styles.tabWrapper}>
      {/* Личные данные */}
      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <Input style={{ width: '220px' }} label='Фамилия' name='lastname' value={mainValues.lastname || ''} onChange={handleMainChange} />
          <Input style={{ width: '220px' }} label='Имя' name='firstname' value={mainValues.firstname || ''} onChange={handleMainChange} />
          <Input style={{ width: '220px' }} label='Отчество' name='patronymic' value={mainValues.patronymic || ''} onChange={handleMainChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input style={{ width: '150px' }} label='Табельный номер' name='perstype' value={mainValues.perstype || ''} onChange={handleMainChange} />
          <Input style={{ width: '100px' }} label='Литер' name='liter' value={mainValues.liter || ''} onChange={handleMainChange} />
          <Input style={{ width: '150px' }} label='Логин' name='login' value={mainValues.login || ''} onChange={handleMainChange} />
        </div>
        <div className={styles.inputsRow}>
          <Select style={{ width: '150px' }} label='Пол' highlight name='sex' value={mainValues.sex || ''} onChange={handleMainChange}>{sex.map(renderOptions)}</Select>
          <Select style={{ width: '150px' }} label='Статус' highlight name='workstatus' value={mainValues.workstatus || ''} onChange={handleMainChange}>{selectValues.map(renderOptions)}</Select>
        </div>
        <div className={styles.inputsRow}>
          <Input style={{ width: '150px' }} label='Дата рождения' highlight name='birthday' value={mainValues.birthday || ''} onChange={handleMainChange} type='date' />
          <Input style={{ width: '150px' }} label='Код ОКАТО места рождения' name='birthplaceokato' value={mainValues.birthplaceokato || ''} onChange={handleMainChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input style={{ width: '100%' }} label='Место рождения' name='birthplace_text' value={mainValues.birthplace_text || ''} onChange={handleMainChange} />
        </div>
        <div className={styles.inputsRow}>
          <Select style={{ width: '250px' }} label='Состояние в браке' name='familystatus' value={mainValues.familystatus || ''} onChange={handleMainChange}>
            {maritalStatuses.map(renderOptions)}
          </Select>
          <div className={styles.inputsRow}>
            <CustomSelect
              title='Гражданство по ОКИН'
              valuesName="citizenokin"
              options={arrayForSelect(okin, 'name', 'idokin')}
              value={mainValues.citizenokin || ''}
              setFieldValue={setMainFieldValue}
              width={400}
              withoutAll
            />
          </div>
        </div>
        <div className={`${styles.inputsRow} ${styles.noWrap}`}>
          <CustomSelect
            title='Характер работы'
            valuesName="worktype"
            options={arrayForSelect(job4, 'name', 'id')}
            value={mainValues.worktype || ''}
            setFieldValue={setMainFieldValue}
            width={200}
            withoutAll
            highlight
          />
          <CustomSelect
            title='Тип'
            valuesName="persstate"
            options={arrayForSelect(workerTypes, 'name', 'id')}
            value={mainValues.persstate || ''}
            setFieldValue={setMainFieldValue}
            width={200}
            withoutAll
            highlight
          />
          <CustomSelect
            title='Вид работы'
            valuesName="kindwork"
            options={arrayForSelect(kindWork, 'name', 'id')}
            value={mainValues.kindwork || ''}
            setFieldValue={setMainFieldValue}
            width={200}
            withoutAll
            highlight
          />
        </div>
        <div className={styles.inputsRow}>
          <CustomSelect
            title='Должность пед. работника для аттестации (основная)'
            valuesName="teacherattestation"
            options={arrayForSelect(teacherAttestation, 'name', 'idattestation')}
            value={mainValues.teacherattestation || ''}
            setFieldValue={setMainFieldValue}
            width={500}
            withoutAll
          />
        </div>
        <div className={styles.inputsRow}>
          <CustomSelect
            title='Должность пед. работника для аттестации (совместит)'
            valuesName="teacherattestationsov"
            options={arrayForSelect(teacherAttestation, 'name', 'idattestation')}
            value={mainValues.teacherattestationsov || ''}
            setFieldValue={setMainFieldValue}
            width={500}
            withoutAll
          />
        </div>
        <div className={styles.inputsRow}>
          <CustomSelect
            title='Штатная должность для ГУКа'
            valuesName="phone_book_entry"
            options={arrayForSelect(staffPositionGuk, 'name', 'id')}
            value={mainValues.phone_book_entry || ''}
            setFieldValue={setMainFieldValue}
            width={400}
            withoutAll
          />
        </div>
      </div>

      {/* Адрес места жительства */}
      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Адрес места жительства</h3>
        <div className={styles.inputsRow}>
          <Input style={{ width: '120px' }} label='Индекс факт.' name='factindex' value={mainValues.factindex || ''} onChange={handleMainChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input style={{ width: '120px' }} label='Индекс пасп.' name='passportindex' value={mainValues.passportindex || ''} onChange={handleMainChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input style={{ width: '100%' }} label='Адрес места жительства по паспорту' highlight name='registration_address' value={mainValues.registration_address || ''} onChange={handleMainChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '150px' }}
            label='Дата регистрации'
            name='registrationdate'
            value={mainValues.registrationdate || ''}
            onChange={handleMainChange}
            type='date'
          />
        </div>
        <div className={styles.inputsRow}>
          <Select style={{ width: '200px' }} label='Тип документа' name='document_type' value={mainValues.document_type || ''} onChange={handleMainChange}>{docTypes.map(renderOptions)}</Select>
          <Input style={{ width: '100px' }} label='Серия' name='document_series' value={mainValues.document_series || ''} onChange={handleMainChange} />
          <Input style={{ width: '150px' }} label='Номер' name='document_number' value={mainValues.document_number || ''} onChange={handleMainChange} />
        </div>
        <div className={styles.inputsRow}>
          <Textarea style={{ width: '100%' }} label='Кем выдан' name='issued_by' value={mainValues.issued_by || ''} onChange={handleMainChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input style={{ width: '150px' }} label='Когда выдан' name='issue_date' value={mainValues.issue_date || ''} onChange={handleMainChange} type='date' />
          <Input style={{ width: '150px' }} label='Код подразделения' name='issuer_code' value={mainValues.issuer_code || ''} onChange={handleMainChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input style={{ width: '250px' }} label='Пенсионное страховое свидетельство (СНИЛС)' name='snils' value={mainValues.snils || ''} onChange={handleMainChange} />
          <Input style={{ width: '150px' }} label='ИНН' name='inn' value={mainValues.inn || ''} onChange={handleMainChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '150px' }}
            label='Дата составления Т-2'
            name='datet2'
            value={mainValues.datet2 || ''}
            onChange={handleMainChange}
            type='date'
          />
        </div>
      </div>

      {/* Трудовой договор */}
      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Трудовой договор</h3>
        <div className={styles.inputsRow}>
          <Input style={{ width: '150px' }} label='Номер' name='contractnumber' value={mainValues.contractnumber || ''} onChange={handleMainChange} />
          <Input style={{ width: '300px' }} label='Доп. сведения' name='contracttext' value={mainValues.contracttext || ''} onChange={handleMainChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input style={{ width: '150px' }} label='Дата приема' highlight name='employment_date' value={mainValues.employment_date || ''} onChange={handleMainChange} type='date' />
          <Input style={{ width: '300px' }} label='Основание прекращения' name='contractendosnovanie' value={mainValues.contractendosnovanie || ''} onChange={handleMainChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '150px' }}
            label='Дата увольнения'
            name='contractenddate'
            value={mainValues.contractenddate || ''}
            onChange={handleMainChange}
            type='date'
          />
          <Input style={{ width: '150px' }} label='Приказ (расп.) №' name='contractendprikaz' value={mainValues.contractendprikaz || ''} onChange={handleMainChange} />
          <Input
            style={{ width: '150px' }}
            label='от'
            name='contractendprikazdate'
            value={mainValues.contractendprikazdate || ''}
            onChange={handleMainChange}
            type='date'
          />
        </div>
      </div>

      {/* Загран паспорт */}
      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Загран паспорт</h3>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '150px' }}
            label='Выдан'
            name='foreignpassportdate'
            value={mainValues.foreignpassportdate || ''}
            onChange={handleMainChange}
            type='date'
          />
          <Input
            style={{ width: '150px' }}
            label='Действует до'
            name='foreignpassportexpiry'
            value={mainValues.foreignpassportexpiry || ''}
            onChange={handleMainChange}
            type='date'
          />
          <Input style={{ width: '100px' }} label='Серия' name='foreignpassportseries' value={mainValues.foreignpassportseries || ''} onChange={handleMainChange} />
          <Input style={{ width: '150px' }} label='Номер' name='foreignpassportnumber' value={mainValues.foreignpassportnumber || ''} onChange={handleMainChange} />
        </div>
      </div>

      {/* Страховой полис */}
      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Страховой полис</h3>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '150px' }}
            label='Действует до'
            name='insurancedate'
            value={mainValues.insurancedate || ''}
            onChange={handleMainChange}
            type='date'
          />
          <Input style={{ width: '100px' }} label='Серия' name='insuranceseria' value={mainValues.insuranceseria || ''} onChange={handleMainChange} />
          <Input style={{ width: '150px' }} label='Номер' name='insurancenumber' value={mainValues.insurancenumber || ''} onChange={handleMainChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input style={{ width: '300px' }} label='Страховая компания' name='insurancecompany' value={mainValues.insurancecompany || ''} onChange={handleMainChange} />
        </div>
      </div>

      {/* RFID */}
      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>RFID</h3>
        <div className={styles.inputsRow}>
          <Input style={{ width: '200px' }} label='Номер карты' name='rfidcard' value={mainValues.rfidcard || ''} onChange={handleMainChange} />
          <Input style={{ width: '200px' }} label='IP адрес входа' name='login_ip' value={mainValues.login_ip || ''} onChange={handleMainChange} />
        </div>
      </div>
    </div>
  )
}
